export const QueryKeyConstants = {
  search: "search"
} as const;
